import { InjectionToken } from '@angular/core';

export enum CurrencyInputDirection {
  LeftToRight,
  RightToLeft
}

export interface CurrencyMaskConfig {
  align: string;
  direction: CurrencyInputDirection;
  allowNegative: boolean;
  decimal: string;
  precision: number;
  prefix: string;
  suffix: string;
  thousands: string;
  selectOnFocus: boolean;
  removeMaskDuringEntry: boolean;
}

export class CurrencyMaskConfig implements CurrencyMaskConfig {
  static createCurrencyConfig(): CurrencyMaskConfig {
    return {
      align: 'right',
      direction: CurrencyInputDirection.LeftToRight,
      allowNegative: true,
      decimal: '.',
      precision: 2,
      prefix: '$ ',
      suffix: '',
      thousands: ',',
      selectOnFocus: true,
      removeMaskDuringEntry: true
    };
  }

  static createMileageConfig(): CurrencyMaskConfig {
    return {
      align: 'left',
      direction: CurrencyInputDirection.RightToLeft,
      allowNegative: false,
      decimal: '.',
      precision: 0,
      prefix: '',
      suffix: '',
      thousands: ',',
      selectOnFocus: false,
      removeMaskDuringEntry: false
    };
  }
}

export let CURRENCY_MASK_CONFIG = new InjectionToken<CurrencyMaskConfig>('currency.mask.config');
